var map = {
	"./angle-bottom.svg": "3b7f",
	"./angle-left.svg": "209c",
	"./angle-right.svg": "3087",
	"./arrow-right.svg": "18f0",
	"./info.svg": "6da4",
	"./integrations.svg": "8e15",
	"./lang.svg": "6232",
	"./media.svg": "c910",
	"./menu-drop.svg": "bfe6",
	"./partners.svg": "fc9d",
	"./spinner.svg": "18ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44fc";